const PointComponent = () => {
  return (
    <>
      <h2>ポイントについて</h2>
      <p>
        わさびは先払いポイント購入制です。
        <br />
        データ通信料はお客様のご負担となります。
      </p>
      <p>
        <span className="note">※</span>1円＝0.75pts
      </p>
      <div className="point-wrapper">
        {/* 通話機能 */}
        <table className="pricing-table">
          <thead>
            <tr>
              <th colSpan={2}>通話機能</th>
              <th colSpan={2}>発信時</th>
              <th colSpan={2}>着信時</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={2}>音声通話</td>
              <td colSpan={4}>200pts/1分</td>
            </tr>
            <tr>
              <td colSpan={2}>ビデオ通話</td>
              <td colSpan={4}>250pts/1分</td>
            </tr>
          </tbody>
        </table>

        {/* その他 */}
        <table className="pricing-table table-two-column">
          <thead>
            <tr>
              <th>その他</th>
              <th>料金</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>画像掲示板　閲覧</td>
              <td>30pts/1枚</td>
            </tr>
            <tr>
              <td>動画掲示板　閲覧</td>
              <td>200pts〜/1本</td>
            </tr>
            <tr>
              <td>プロフィール　閲覧</td>
              <td className="bold point-color">無料</td>
            </tr>
            <tr>
              <td>ブログ投稿</td>
              <td className="bold point-color">無料</td>
            </tr>
          </tbody>
        </table>

        {/* メッセージ機能 */}
        <table className="pricing-table">
          <thead>
            <tr>
              <th colSpan={2}>メッセージ機能</th>
              <th>受信時</th>
              <th>送信時</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={2}>メール送信</td>
              <td className="bold point-color">無料</td>
              <td>80pts/1通</td>
            </tr>
            <tr>
              <td colSpan={2}>画像添付</td>
              <td>50pts/1通</td>
              <td>100pts/1通</td>
            </tr>
            <tr>
              <td colSpan={2}>動画添付</td>
              <td>100pts/1通</td>
              <td>150pts/1通</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PointComponent;
